<template>
  <Teleport to="body">
    <div v-if="isVisible" class="modal-overlay" @click="closeModal">
      <div class="modal" @click.stop>
        <div class="modal-close" @click="closeModal">
          <i class="fas fa-times"></i>
        </div>
        <h3 class="modal-title">{{ title }}</h3>
        <div class="modal-content">
          <PrivacyPolicy v-if="modalType === 'privacy'" />
          <UserAgreement v-else-if="modalType === 'agreement'" />
          <AboutUs v-else-if="modalType === 'about'" />
          <slot v-else></slot>
        </div>
        <slot name="footer"></slot>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import PrivacyPolicy from './PrivacyPolicy.vue'
import UserAgreement from './UserAgreement.vue'
import AboutUs from './AboutUs.vue'

const props = defineProps({
  isVisible: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Modal'
  },
  modalType: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close'])

const closeModal = () => {
  emit('close')
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.8);
  backdrop-filter: blur(8px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
}

.modal {
  background: #1e293b;
  border: 1px solid rgba(94, 234, 212, 0.2);
  border-radius: 16px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow: hidden;
  padding: 2rem;
  position: relative;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(94, 234, 212, 0.1);
  color: #5eead4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
}

.modal-close:hover {
  background: rgba(94, 234, 212, 0.2);
  transform: scale(1.1);
}

.modal-title {
  font-size: 1.4rem;
  color: #5eead4;
  margin-bottom: 1.5rem;
  padding-right: 40px;
}

.modal-content {
  color: #cbd5e1;
  line-height: 1.7;
  font-size: 0.95rem;
  max-height: calc(80vh - 8rem);
  overflow-y: auto;
  padding-right: 8px;
}

.modal-content p {
  margin-bottom: 1rem;
}

/* 模态框内容滚动条样式 */
.modal-content::-webkit-scrollbar {
  width: 6px;
}

.modal-content::-webkit-scrollbar-track {
  background: rgba(30, 41, 59, 0.2);
  border-radius: 3px;
}

.modal-content::-webkit-scrollbar-thumb {
  background: rgba(94, 234, 212, 0.4);
  border-radius: 3px;
  transition: background 0.3s ease;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: rgba(94, 234, 212, 0.6);
}

.modal-content::-webkit-scrollbar-thumb:active {
  background: rgba(94, 234, 212, 0.8);
}

/* Firefox 内容滚动条 */
.modal-content {
  scrollbar-width: thin;
  scrollbar-color: rgba(94, 234, 212, 0.4) rgba(30, 41, 59, 0.2);
}

@media (max-width: 500px) {
  .modal {
    padding: 1.5rem;
    margin: 10px;
  }

  .modal-title {
    font-size: 1.2rem;
  }
}
</style>